import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
//Import all the component to map
import * as ComponentsLoaded from './LoadComponents'
//Load route config
const Routes = require('./Routes.json');

//Iterate all the components imported and store in array object
const ComponentRender = {}
for (let component in ComponentsLoaded) {
    if(!ComponentsLoaded.hasOwnProperty(component)) continue;
	ComponentRender[component] = ComponentsLoaded[component]
}
/**
 * Component to mapping the URLs with a specific component
 */
const RoutesApp = () => (
    <Router>    
            <Switch>
                {Routes.map(
			(route, index) => (route.type === "Route" ?
                        <Route exact path={route.path} component={ComponentRender[route.component]} key={index} />
                                :
                        <ComponentRender.PrivateRoute path={route.path} data={route.data} Component={ComponentRender[route.component]} key={index} />
                ))}
            </Switch>
    </Router>
)
    
export default RoutesApp;


// WEBPACK FOOTER //
// ./src/client/RoutesApp.js